import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit/modal';
import { useDispatch, useSelector } from 'react-redux';
import { ElementInViewport } from '../../../../packages/ElementInViewport';
import { changePhone, confirmPhone, confirmPhoneError } from '../../actions/phone';
import { setTrackLabel } from '../../actions/trackLabel';
import { trackShowInput, trackStartInput, trackButtonClick } from './tracking';
import { selectPhoneNumber, selectPhoneError, selectFetchPhoneStatus } from '../../selectors/phone';
import { EStatus, TLabel } from '../../types/auth';
import { FINANCE_PROCESSING_PERSONAL_DATA_TEXT } from '../../constants/mortgage';
import { selectUserStatus } from '../../selectors/user';
import { EUserStatus } from '../../types/userStatus';
import { IShowcase } from '../../types/showcase/props';

export interface ISubmitPhoneFormContainer {
  Form: React.ComponentType<IShowcase>;
  formTitle?: string;
  label: TLabel;
}

export const SubmitPhoneFormContainer: React.FC<ISubmitPhoneFormContainer> = ({
  Form,
  label,
  formTitle = 'Начните заполнение анкеты',
}) => {
  const [touched, setTouched] = React.useState<boolean>(false);
  const [open, setOpen] = React.useState<boolean>(false);

  const dispatch = useDispatch();
  const userStatus = useSelector(selectUserStatus);
  const phone = useSelector(selectPhoneNumber);
  const error = useSelector(selectPhoneError);
  const fetchPhoneStatus = useSelector(selectFetchPhoneStatus);

  const submitPhone = () => {
    trackButtonClick(label);
    dispatch(setTrackLabel(label));
    dispatch(confirmPhone());
  };

  const setPhone = (phone: string) => {
    if (!touched) {
      setTouched(true);
      trackStartInput(label);
      dispatch(setTrackLabel(label));
    }

    if (error) {
      dispatch(confirmPhoneError(''));
    }

    dispatch(changePhone(phone));
  };

  const onElementInViewPort = React.useCallback(() => {
    trackShowInput(label);
  }, [label]);

  return (
    <>
      <ElementInViewport onVisibleFirst={onElementInViewPort}>
        <Form
          formTitle={formTitle}
          buttonTitle={userStatus === EUserStatus.Visited ? 'Получить код' : 'Зарегистрироваться'}
          loading={fetchPhoneStatus === EStatus.LOADING}
          error={error}
          phone={phone}
          submitPhone={submitPhone}
          setPhone={setPhone}
          setOpen={setOpen}
        />
      </ElementInViewport>

      <ModalWindow
        escape
        outside
        content={FINANCE_PROCESSING_PERSONAL_DATA_TEXT}
        open={open}
        fixed={false}
        maxWidth={616}
        onClose={() => {
          setOpen(false);
        }}
        title="Согласие на обработку персональных данных"
      />
    </>
  );
};
